<template>
    <div class="content content--registration">
        <div class="small-window">
            <div class="form-wrap">
                <h1 class="form-wrap__title form-wrap__title--sticky">Способ подписания документа</h1>
                <div class="form-wrap__row form-wrap__row--checkbox">
                    <c-checkbox v-model="digitalSignatureFlag" :label="'С помощью ЭЦП'" :labelClass="'checkbox__label-text--purple'">
                        <p class="text">
                            Подписание договора с помощью электронной цифровой подписи (ЭЦП)
                            Выбирая этот способ, вы можете подать заявку на микрокредит с любого города Казахстана <br>
                            <strong>Убедитесь, что ваш ЭЦП не просрочен</strong>
                        </p>
                    </c-checkbox>
                </div>
                <div class="form-wrap__row form-wrap__row--checkbox ">
                    <c-checkbox v-model="physicalSignatureFlag" :label="'Получить документы от курьера'" :labelClass="'checkbox__label-text--purple'">
                        <p class="text">
                            <strong>Только для Алматы и Алматинской области</strong> <br>
                            курьер привезет документы на удобный для вас адрес. Срок доставки - до 3 дней
                        </p>
                    </c-checkbox>
                </div>
                <div class="form-button__wrap" v-if="physicalSignatureFlag || digitalSignatureFlag">
                    <button class="form-button form-button--yellow form-button--long-text" v-on:click="confirmLoan">
                        Отправить заявку
                    </button>
                </div>

                <loan-loader :showLoader="showLoader"></loan-loader>
            </div>
        </div>
    </div>
</template>

<script>
    import each from 'lodash/each';
    import {createHelpers} from 'vuex-map-fields';
    import widthMixin from '@/modules/mixins/widthMixin'
    import Raven from 'raven-js'

    const {mapFields: creditFields} = createHelpers({
        getterType: 'credit/getField',
        mutationType: 'credit/updateField',
    });

    const LOAN_SUCCESS = [
        'MANUAL_VERIFICATION',
        'REMITTANCE_PREPARED',
        'ON_MANUAL_VERIFICATION',
        'APPROVED',
        'WAITING_SIGN_AGREEMENTS_BY_DIGITAL_SIGNATURE',
        'APPROVED_WAITING_SIGN_CONTRACT_BY_PHYSICAL_SIGNATURE'

    ];
    const LOAN_REJECT = [
        'CANCELED',
        'REJECTED'
    ];

    export default {
        name: 'Treatment',
        mixins: [widthMixin],
        metaInfo: {
            title: 'Регистрация'
        },
        data() {
            return {
                digitalSignatureFlag: false,
                physicalSignatureFlag: false,
                showLoader: false,
            }
        },
        watch: {
            digitalSignatureFlag: function (newVal, oldVal) {
                if(newVal){
                    this.physicalSignatureFlag = false;
                }

            },
            physicalSignatureFlag: function (newVal, oldVal) {
                if(newVal){
                    this.digitalSignatureFlag = false;
                }
            }
        },
        computed: {

            ...creditFields([
                'creditID',
                'bankID',
                'IBAN',
                'IBANExternalStatus',
                'IBANExternalError',
            ]),
        },
        methods: {
            uncheckAll: function () {
                if( this.allComplete ){
                    this.loanRules = false;
                    this.allConditions = false;
                    this.GCVP = false;
                    this.getFromPKB = false;
                    this.sendToPKB = false;
                }
            },
            confirmLoan: function () {
                let _this = this;
                let data = new URLSearchParams();

                data.append('documentType', 'OFFER');
                data.append('creditId', this.creditID);
                if(this.digitalSignatureFlag){
                    data.append('digitalSignatureFlag', this.digitalSignatureFlag)
                }else if( this.physicalSignatureFlag){
                    data.append('physicalSignatureFlag', this.physicalSignatureFlag)
                }
                this.showLoader = true;
                this.$http.post('/json/document/confirmation', data).then(
                    (response) => {
                        if( response.data.code === 0){
                            Raven.captureMessage('Step end: '+_this.$options.name, {
                                level: 'info'
                            });
                            _this.StartPullingForStatus();
                        }else{
                            this.showLoader = false;
                            alert('Произошла ошибка. Повторите позже.')
                        }
                    },
                    (response) => {

                    }
                )

            },
            StartPullingForStatus: function () {
                let _this = this;
                let timer = setInterval(function () {
                    _this.$http.get('/json/decision/id', {params : { creditId: _this.creditID}}).then(
                        (response) => {
                            if (  LOAN_SUCCESS.indexOf(response.data.data) > -1){
                                Raven.captureMessage('SUCCESS. LOAN STATUS - ' + response.data.data, {
                                    level: 'info'
                                });



                                clearInterval(timer);
                                setTimeout(function () {
                                    _this.showLoader = false;
                                    _this.$router.push({name: 'CabinetIndex'})
                                }, 3000);
                            }else if( LOAN_REJECT.indexOf(response.data.data) > -1){
                                Raven.captureMessage('FAIL. LOAN STATUS - ' + response.data.data, {
                                    level: 'info'
                                });

                                clearInterval(timer);
                                setTimeout(function () {
                                    _this.showLoader = false;
                                    _this.$router.push({name: 'Decline'})
                                }, 3000);
                            }else {
                                Raven.captureMessage('FAIL. LOAN STATUS - ' + response.data.data, {
                                    level: 'error'
                                });
                                // TODO Какой то неизвестный статус, чекаем проверям, радуемся :D
                            }
                        },
                        (response) => {

                        }
                    )
                }, 1000)
            }
        },
        beforeCreate(){
            if( !this.$store.getters['profile/isInited'] ){
                this.$store.dispatch('profile/INIT');
            }
        },
        mounted() {
            this.$store.commit('CHANGE_PROGRESS', {progressBarShow: true, currentPercent: 90, nextPercent: 5});
            this.$store.dispatch('credit/GET_CREDIT_INFO');
        }
    }
</script>

<style lang="scss">
    @import "~@/assets/scss/variable";
    .link{
        font-size: 14px;
        font-family: $RobotoRegular;
        line-height: 16px;
        text-decoration: underline;
        &--orange{
            color: $orange;
            &:hover{
                color: #cd7013;
            }
        }
    }
    .modal-header{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px 15px;
        background: $gray-light;
        position: fixed;
        width: 100%;
        top: 0;
        left: 0;
        &__title{
            text-align: left;
            font-size: 18px;
            font-family: $RobotoRegular;
        }
        &__close{
            color: $purple-site;
            font-size: 18px;
            text-decoration: underline;
            &:hover{
                cursor: pointer;
                color: #6d1a69;
            }
        }
    }
    .modal-content{
        padding-top: 60px;
    }
    .text{
        font-family: $RobotoRegular;
        font-size: 14px;
        color: #4a4a4a;
        line-height: 1.5;
        strong{
            font-family: $RobotoBold;
            font-weight: normal;
            font-size: 14px;
        }
    }
    @media screen and (max-width: 768px){
        .modal-header{
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            padding: 10px 15px;
            background: $gray-light;
            &__title{
                text-align: left;
                font-size: 14px;
                font-family: $RobotoRegular;
            }
            &__close{
                color: $purple-site;
                font-size: 12px;
                text-decoration: underline;
                &:hover{
                    cursor: pointer;
                    color: #6d1a69;
                }
            }
        }
    }
</style>